import { Currency } from './types/Currencies';
import { Language } from '@ha/intl';
import { ListingsSummary } from './types/ListingsSummary';
import { MakeCall } from './createMakeCall';

export interface Query {
  userId: number | null;
  withListingState?: string;
  minPrice?: number;
  maxPrice?: number;
  currency?: Currency;
  from?: string;
  to?: string;
  lang?: Language;
  query?: string;
  withCharitable?: boolean;
}

export type GetListingsSummaryCall = (
  data: Query,
) => Promise<{ data: ListingsSummary }>;

const getListingsSummary =
  (makeCall: MakeCall) =>
  ({
    currency,
    from,
    lang,
    maxPrice,
    minPrice,
    query,
    to,
    userId,
    withCharitable,
    withListingState,
  }: Query) =>
    makeCall<ListingsSummary>('GET', `/api/v2/listings/summary`, {
      query: {
        currency,
        from,
        lang,
        maxPrice,
        minPrice,
        query,
        to,
        userId,
        withCharitable,
        withListingState,
      },
    });
export { getListingsSummary };
